import React, {PropsWithChildren, useMemo} from "react";
import {useVisitor} from "@ct-react/visitor";
import {useLocation} from "react-router-dom";

const ProtectedRoute = ({ children }: PropsWithChildren) => {

  const { isLoggedIn } = useVisitor();
  const location = useLocation();

  const target = useMemo(() =>
    encodeURIComponent(location.pathname + location.search + location.hash),
    [ location ]);

  if (!isLoggedIn) {
    window.location.replace(`/login?target=${target}`);
    return null;
  }

  return <>{children}</>;

}

export default ProtectedRoute;
